import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const SuccessIcon = (props: IIconProps) => {
  const { width = 38, height = 37, color = 'currentColor' } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.1784 9.75146L10.6742 15.0025L7.92676 12.377"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0467 21.004C17.0182 21.004 21.0485 16.9738 21.0485 12.0023C21.0485 7.03072 17.0182 3.00049 12.0467 3.00049C7.07515 3.00049 3.04492 7.03072 3.04492 12.0023C3.04492 16.9738 7.07515 21.004 12.0467 21.004Z"
        stroke={color}
        strokeWidth="1.50029"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(SuccessIcon);
